export interface NoChangeInput {
  /** Whether the maker-checker module is on for this bot. */
  makerCheckerEnabled: boolean;
  /** The node in the editor deep-equals the baseline taken when it was opened. */
  nodeIsUnchanged: boolean;
  /** The node's id is the one it had when it was opened. */
  idIsUnchanged: boolean;
  /** The sticky-menu setting was changed alongside the node. */
  stickyMenuChanged: boolean;
  /** The node exists only in this browser — it has never been saved. */
  isUnsavedNewNode: boolean;
}

/**
 * Decides whether a save would queue nothing for approval, so the editor can
 * say so instead of saving.
 *
 * A node that has never been saved is not "unchanged" however closely it
 * matches its baseline: the baseline is a copy of the node itself, so it will
 * always match, and saving is what creates the node on the server. Treating it
 * as unchanged made a freshly added version impossible to save without editing
 * it first (KR-11003).
 */
export function isNoChangeSave({
  makerCheckerEnabled,
  nodeIsUnchanged,
  idIsUnchanged,
  stickyMenuChanged,
  isUnsavedNewNode,
}: NoChangeInput): boolean {
  return (
    makerCheckerEnabled &&
    nodeIsUnchanged &&
    idIsUnchanged &&
    !stickyMenuChanged &&
    !isUnsavedNewNode
  );
}
